import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {getAccountId, setAccountId} from './FacebookAccountIdRepo';
import t from 'rcm-i18n';

//@TODO handle API 404s and 401s
export default class FacebookAnalyticsEditController extends Component {
    constructor(props) {
        super(props);
        this.state = {accountId: '', loading: true, successfullySaved: false, networkErrorOccurred: false};
        this.handleAccountIdChange = this.handleAccountIdChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleNetworkError = this.handleNetworkError.bind(this);
    }

    handleNetworkError(errorResponse) {
        if (errorResponse.status && errorResponse.status === 401) {
            window.location.href = '/login?redirect=' + encodeURIComponent(window.location.href);
        } else {
            this.setState({loading: false, networkErrorOccurred: true});
        }
    }

    componentDidMount() {
        const self = this;
        getAccountId(this.props.siteId).then((accountId) => {
            self.setState({accountId: accountId, loading: false});
        }).catch(self.handleNetworkError);
    }

    handleAccountIdChange(event) {
        this.setState({accountId: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
        const self = this;
        self.setState({successfullySaved: false, loading: true, networkErrorOccurred: false});
        setAccountId(this.props.siteId, this.state.accountId).then(() => {
            self.setState({successfullySaved: true, loading: false});
        }).catch(self.handleNetworkError);
    }

    render() {
        return (
            <div>
                {!this.state.loading &&
                <form onSubmit={this.handleSubmit}>
                    {this.state.networkErrorOccurred &&
                    <div className="alert alert-danger">
                        {t('An error occurred. Please check your internet connection and try again.')}
                    </div>
                    }
                    {this.state.successfullySaved &&
                    <div className="alert alert-success">{t('Your changes have been saved.')}</div>
                }
                    <div>
                        <h2>{t('Facebook Pixel Analytics Settings')}</h2>
                        <p>
                            {t('This page allows you to connect your website to Facebook Pixel Analytics. The Pixel events dashboard is provided by Facebook at')}
                            &nbsp;
                            <a href="https://www.facebook.com/events_manager/pixel/">
                                https://www.facebook.com/events_manager/pixel/
                            </a>
                        </p>
                        <br />
                        <p>{t('Facebook Pixel Analytics Setup Instructions:')}</p>
                        <br />
                        <p>
                            {t('Step 1) Login to Facebook and get a Pixel ID.')}
                            &nbsp;
                            <strong>
                                {t('NOTE: Your Pixel ID is different from your Facebook account ID. Do not use your Facebook account ID. It will not work.')}
                            </strong><br />
                            {t('Step 2) Enter your Pixel ID in the field below and click "save".')}<br />
                            {t('Step 3)')}
                            &nbsp;
                            <a href="https://www.facebook.com/events_manager/pixel/">
                                {t('View analytics from your website.')}
                            </a>
                        </p>
                        <br />
                    </div>
                    <div className="form-group">
                        <label htmlFor="accountIdInput">{t('Facebook Pixel ID:')}</label>
                        <input value={this.state.accountId}
                               onChange={this.handleAccountIdChange}
                               type="text"
                               className="form-control" id="accountIdInput"
                               aria-describedby="accountIdHelp"/>
                        <br />
                        <small id="accountIdHelp" className="form-text text-muted">
                            {t('This is a long number that you can get from the Facebook Pixel Source Code.')}
                        </small>
                    </div>
                    <button type="submit" className="btn btn-primary">{t('Save')}</button>
                </form>
                }
                {this.state.loading && <div className="text-center">{t('Loading...')}</div>}
            </div>
        );
    }

    static propTypes = {
        siteId: PropTypes.string.isRequired,
    };
}
